export enum ReconfigureAgentType {
  Add = 1,
  Remove = 2,
  Match = 3,
}

export enum ReconfigureAgentTypeEvent {
  OnReconfigureTypeRadioSelectionChanged = 'onReconfigureTypeRadioSelectionChanged',
}

export class OnReconfigureAgentTypeSelect extends CustomEvent<{ reconfigureAgentType: ReconfigureAgentType }> {
  constructor(reconfigureAgentType: ReconfigureAgentType) {
    super(ReconfigureAgentTypeEvent.OnReconfigureTypeRadioSelectionChanged, {
      detail: {
        reconfigureAgentType,
      },
      bubbles: true,
      composed: true,
    });
  }
}
